var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.access)?_c('icon',{staticClass:"access-granted-lock",attrs:{"name":"unlock"}}):_c('icon',{staticClass:"access-denied-lock",attrs:{"name":"lock"}})}
var staticRenderFns = []

export { render, staticRenderFns }